import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';

import * as yup from 'yup';

/** Project workflow APIs permissions for current authorized user - DTO signature */
export interface ProjectWorkflowPermissionsInterface {
  /** Can user call `GET /api/v1/project/:id/workflow/assign` */
  canAssign: boolean;
  /** Can user call `GET /api/v1/project/:id/workflow/take-to-work` */
  canTakeToWork: boolean;
  /** Can user call `GET /api/v1/project/:id/workflow/submit-for-review` */
  canSubmitForReview: boolean;
  /** Can user call `GET /api/v1/project/:id/workflow/bring-back-to-work` */
  canBringBackToWork: boolean;
  /** Can user call `GET /api/v1/project/:id/workflow/pause` */
  canPause: boolean;
  /** Can user call `GET /api/v1/project/:id/workflow/accept` */
  canAccept: boolean;
  /** Can user call `GET /api/v1/project/:id/workflow/cancel` */
  canCancel: boolean;
  /** Can user call `GET /api/v1/project/:id/workflow/convert-to-theme` */
  canConvertToTheme: boolean;
}

/** Project workflow APIs permissions for current authorized user - DTO schema */
export const ProjectWorkflowPermissionsDto = SerdeDtoClass.create<ProjectWorkflowPermissionsInterface>(ProjectDtoKeysEnum.PROJECT_WORKFLOW_PERMISSIONS_DTO, {
  canAssign: {
    label: 'Можно назначить ответственного',
    serializer: yup.boolean(),
  },
  canTakeToWork: {
    label: 'Можно взять в работу',
    serializer: yup.boolean(),
  },
  canSubmitForReview: {
    label: 'Можно отправить на проверку',
    serializer: yup.boolean(),
  },
  canBringBackToWork: {
    label: 'Можно вернуть в работу',
    serializer: yup.boolean(),
  },
  canPause: {
    label: 'Можно приостановить',
    serializer: yup.boolean(),
  },
  canAccept: {
    label: 'Можно принять',
    serializer: yup.boolean(),
  },
  canCancel: {
    label: 'Можно снять',
    serializer: yup.boolean(),
  },
  canConvertToTheme: {
    label: 'Можно преобразовать в тему',
    serializer: yup.boolean(),
  },
});
